export const TABS = {
  GENERAL_INFO: 0,
  INVOICES: 1,
  TRANSACTIONS: 2,
  BANK: 3,
};
